
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'

import { getCookie, setCookie, removeCookie } from "../common/js/utils";
import router from "../router/index.js";
import {
initWxJSSDK,
getWelfareList,
getProductList,
getOrder
} from "../common/js/api.js";
import { bannerList, baseUrl } from "../common/js/config";
import wx from "weixin-js-sdk";
export default {
directives: {},
components: {
Scroller,
Tab,
TabItem,
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Icon,
Sticky
},
data() {
return {
orderId: "",
orderInfo: {},
productSource: [],
productOption: {
pageIndex: 1,
pageSize: 3,
extInfo: {}
},
dataWelfareSource: [],
pageWelfareOption: {
pageIndex: 1,
pageSize: 1,
extInfo: {}
},
view: {
title: "",
description: "操作成功！",
icon: "success",
buttons: [





{
type: "default",
text: "回到首页",
link: "/"
}
]
}
};
},
methods: {
getOrder() {
let self = this;
getOrder({ data: { orderId: self.orderId } }).then(function(data) {
self.orderInfo = data.Content;
});
},
getProductList() {
let self = this;
const option = {
url: baseUrl + "/shop/wxapp/relationTag/getAppointmenntProductRegList",
data: JSON.stringify(self.productOption)
};
getProductList(option).then(function(data) {
self.productSource = data.Content;
});
},
WelfareActivityDetail(activityId) {
const self = this;
wx.miniProgram.navigateTo({
url: "/pages/welfareDetail?activityId=" + activityId,
fail: () => {
self.$vux.toast.text("近期开放，敬请留意!", "middle");
}
});
},
WelfareActivityList() {
const self = this;
wx.miniProgram.navigateTo({
url: "/pages/welfareList",
fail: () => {
self.$vux.toast.text("近期开放，敬请留意!", "middle");
}
});
},
shopIndex() {
const self = this;
wx.miniProgram.navigateTo({
url:"/pages/index",
fail: () =>  {
self.$vux.toast.text('近期开放，敬请留意!', 'middle')
}
})
},
productDetail(activityId) {
const self = this;
wx.miniProgram.navigateTo({
url:"/pages/productDetail?activityId=" + activityId,
fail: () =>  {
self.$vux.toast.text('近期开放，敬请留意!', 'middle')
}
})
},
orderDetail () {
const self = this
self.$router.push({
path: "usercenter/orderDetail",
query: { orderId: self.orderId }
});
},
getWelfareActivity() {
let self = this;
const option = {
url: baseUrl + "/shop/wxapp/welfareActivity/getList",
data: JSON.stringify(self.pageWelfareOption)
};
getWelfareList(option).then(function(data) {
self.dataWelfareSource = data.Content;
});
},
confirmTime() {
this.$wechat.launchMiniProgram({
targetAppId: "wxf0c90a1559baab40",
path: "",
envVersion: "release"
});



},
closeWindow() {
this.$wechat.closeWindow();
}
},
created() {
if (this.$route.query.orderId) {
this.orderId = this.$route.query.orderId;
} else {
this.orderId = "00000006723";
}
let message = this.$route.query.message;
this.view.description = message;
initWxJSSDK();
this.getOrder();
this.getWelfareActivity();
this.getProductList();
}
};



// WEBPACK FOOTER //
// ./src/components/AppointmentSuccess.vue